import React from 'react';
import { ChartRendererSupabase } from './ChartRendererSupabase';
import { fetchInventoryComparisonData } from '../../services/inventoryComparisonService';
import { useEffect, useState } from 'react';

interface InventoryComparisonChartProps {
  location: string;
}

export const InventoryComparisonChart: React.FC<InventoryComparisonChartProps> = ({ location }) => {
  const [chartData, setChartData] = useState<any>(null);
  const [chartOptions, setChartOptions] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      if (!location) return;
      
      try {
        setLoading(true);
        const result = await fetchInventoryComparisonData(location);
        setChartData(result.chartData);
        setChartOptions(result.chartOptions);
      } catch (error) {
        console.error('Error loading inventory comparison data:', error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [location]);

  if (loading || !chartData || !chartOptions) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '500px',
        fontSize: '16px',
        color: '#6b7280'
      }}>
        Loading comparison data...
      </div>
    );
  }

  return (
    <ChartRendererSupabase
      chartData={chartData}
      chartOptions={chartOptions}
      height="500px"
    />
  );
};

